import { graphql } from 'gatsby';
import { GatsbyImage, getSrc } from 'gatsby-plugin-image';
import React from 'react';
import { useIntl } from 'react-intl';
import ArticleHeader from '~/components/ArticleHeader';
import ContentWrapper from '~/components/ContentWrapper';
import { LanguageContext } from '~/components/LanguageProvider';
import Layout from '~/components/Layout';
import PortableText from '~/components/PortableText';
import { toPlainText } from '~/lib/helpers';

const InformasjonTilLeverandorer = ({ data }) => {
  const leverandorer = data.allSanityInfotilleverandor.edges[0].node;
  const { language } = React.useContext(LanguageContext);
  const { formatMessage: f } = useIntl();
  return (
    <>
      <ArticleHeader
        title={leverandorer.title[language]}
        excerpt={toPlainText(leverandorer._rawExcerpt[language])}
        imageSrc={getSrc(
          data.leverandorerImage.childImageSharp.gatsbyImageData
        )}
        alt={f({ id: 'mountaintrain.image.alt' })}
      />
      <ContentWrapper style={{ overflowWrap: 'break-word' }}>
        <PortableText blocks={leverandorer._rawContent[language]} />
      </ContentWrapper>
    </>
  );
};

export const query = graphql`
  query InformasjonTilLeverandor {
    allSanityInfotilleverandor {
      edges {
        node {
          title {
            nb
            en
            nn
          }
          _rawExcerpt
          _rawContent
        }
      }
    }
    leverandorerImage: file(
      relativePath: { eq: "Bedrift/Kontakt og info/Leverandorer.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
  }
`;

export default InformasjonTilLeverandorer;
